<as-split direction="horizontal" useTransition="true">
  <as-split-area [size]="30">
    <data-mapping-grid
      [dataMapping]="categoryMapping"
      (rowsSelectedIndices)="filterByCategory($event)"></data-mapping-grid>
  </as-split-area>
  <as-split-area [size]="70">
    <data-mapping-grid [dataMapping]="variableMapping"></data-mapping-grid>
  </as-split-area>
</as-split>
